import { Link } from 'react-router-dom';
import { blogPostsData } from '../../../mocks/blog';

const BlogSection = () => {
  return (
    <section className="py-24 bg-cream-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <p className="text-orange-600 text-sm font-sans font-semibold tracking-wider mb-6">
            /INDUSTRY INSIGHTS
          </p>
          <p className="font-sans text-4xl text-gray-800 leading-relaxed max-w-4xl">
            Stay informed with the latest tax strategies, regulatory updates, and financial planning insights from our expert team
          </p>
        </div>

        <div className="overflow-x-auto pb-6">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {blogPostsData.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
                style={{ width: '380px' }}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  {post.aiGenerated && (
                    <div className="absolute top-4 right-4 bg-purple-600 text-white px-3 py-1 rounded-full text-xs font-sans font-semibold flex items-center gap-1">
                      <i className="ri-sparkling-line"></i>
                      AI-Enhanced
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-xs font-sans font-semibold">
                      {post.category}
                    </span>
                    <span className="text-gray-500 text-xs font-sans">{post.readTime}</span>
                  </div>
                  <h3 className="font-montserrat font-bold text-xl text-gray-900 mb-3 line-clamp-2 group-hover:text-orange-500 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 font-sans text-sm leading-relaxed line-clamp-3 mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-orange-500 font-sans font-semibold text-sm group-hover:gap-3 transition-all">
                    Read More
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 bg-orange-500 text-white px-8 py-4 rounded-full font-sans font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
